import React, { useState } from 'react';
import { GraduationCap } from 'lucide-react';
import checkIconBlack from "../assets/icons/CheckIconBlack.svg";
import ScreeningIcon from "../assets/icons/ScreeningIcon.svg";
import TrainingIcon from "../assets/icons/TrainingIcon.svg";
import VehicleIcon from "../assets/icons/VehicleIcon.svg";
import FeatureIcon from "../assets/icons/FeatureIcon.svg";
import VerifiedIcon from "../assets/icons/VerifiedIcon.svg";
import InsuranceIcon from "../assets/icons/InsuranceIcon.svg";

import './SafetySection.css';

const SafetySection = () => {
  const [activeTab, setActiveTab] = useState('driver');

  const driverSafety = [
    {
      title: 'Driver Screening',
      description: 'All drivers undergo comprehensive screening:',
      icon: ScreeningIcon,
      items: [
        'Criminal record checks',
        'Driving record reviews (minimum 3-year history)',
        'Annual re-certification',
        'Continuous monitoring',
        '100% completion rate maintained'
      ]
    },
    {
      title: 'Driver Training',
      description: 'Rigorous training program covering:',
      icon: TrainingIcon,
      items: [
        'Defensive driving techniques',
        'Emergency response procedures',
        'Customer service excellence',
        'Conflict de-escalation',
        'Platform and safety protocols'
      ]
    },
    {
      title: 'Vehicle Standards',
      description: 'Strict vehicle requirements ensure passenger safety:',
      icon: VehicleIcon,
      items: [
        'Annual comprehensive inspections',
        'Maximum 8-year vehicle age limit',
        'Commercial insurance requirements ($5M liability minimum)',
        'Emergency equipment mandatory',
        'Regular maintenance verification'
      ]
    }
  ];

  const riderSafety = [
    {
      title: 'Ride Safety Features',
      description: 'Real-Time Protection:',
      icon: FeatureIcon,
      items: [
        'GPS tracking on every ride',
        'Share trip status with family/friends',
        'Emergency button with automatic location sharing',
        '24/7 emergency response team',
        'Automatic emergency service notification'
      ]
    },
    {
      title: 'Verified Information',
      icon: VerifiedIcon,
      items: [
        'Driver photo and vehicle details before pickup',
        'License plate verification',
        'Real-time driver location',
        'Estimated arrival times',
        'Complete ride history and receipts'
      ]
    },
    {
      title: 'Insurance Coverage',
      icon: InsuranceIcon,
      items: [
        '$5 million liability coverage per incident',
        'Comprehensive auto insurance',
        'Cybersecurity protection',
        'Professional liability insurance',
      ]
    }
  ];

  const currentSafety = activeTab === 'driver' ? driverSafety : riderSafety;

  return (
    <section id="safety" className="safety-section">
      <div className="section-container">
        <div>
          <h2 className="section-title">Safety Standards</h2>
        </div>
        <div className="safety-tabs">
          <button
            className={`tab-button ${activeTab === 'driver' ? 'active' : ''}`}
            onClick={() => setActiveTab('driver')}
          >
            Driver Safety
          </button>
          <button
            className={`tab-button ${activeTab === 'rider' ? 'active' : ''}`}
            onClick={() => setActiveTab('rider')}
          >
            Rider Safety
          </button>
        </div>
        <div className="safety-content">
          <div className="safety-grid">
            {currentSafety.map((item, index) => (
              <div key={index} className="safety-card">
                <div className="safety-icon-wrapper">
                  <img src={item.icon} alt={item.title} className="safety-icon" />
                </div>
                <h3 className="safety-card-title">{item.title}</h3>
                <p className="safety-card-description">{item.description}</p>
                <ul className="safety-checklist">
                  {item.items.map((checkItem, idx) => (
                    <li key={idx} className="checklist-item">
                       <img src={checkIconBlack} alt="check icon" className="check-icon" />
                      <span>{checkItem}</span>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default SafetySection;